export const BOOKABLE_PACKAGE_RATE_ACTION = "BOOKABLE_PACKAGE_RATE_ACTION";
export const BOOKABLE_PACKAGE_RATE_SUCCESS = "BOOKABLE_PACKAGE_RATE_SUCCESS";
export const BOOKABLE_PACKAGE_RATE_FAIL = "BOOKABLE_PACKAGE_RATE_FAIL";
export const BOOKABLE_PACKAGE_RATES_SYNC_ACTION = "BOOKABLE_PACKAGE_RATES_SYNC_ACTION";
export const BOOKABLE_PACKAGE_RATES_SYNC_SUCCESS = "BOOKABLE_PACKAGE_RATES_SYNC_SUCCESS";
export const BOOKABLE_PACKAGE_RATE_SYNC_ACTION = "BOOKABLE_PACKAGE_RATE_SYNC_ACTION";
export const BOOKABLE_PACKAGE_RATE_SYNC_SUCCESS = "BOOKABLE_PACKAGE_RATE_SYNC_SUCCESS";
export const BOOKABLE_PACKAGE_RATE_DETAIL_ACTION = "BOOKABLE_PACKAGE_RATE_DETAIL_ACTION";
export const BOOKABLE_PACKAGE_RATE_DETAIL_SUCCESS = "BOOKABLE_PACKAGE_RATE_DETAIL_SUCCESS";
export const BOOKABLE_PACKAGE_RATE_UPDATE_ACTION = "BOOKABLE_PACKAGE_RATE_UPDATE_ACTION";
export const BOOKABLE_PACKAGE_RATE_SORT_ACTION = "BOOKABLE_PACKAGE_RATE_SORT_ACTION";
export const BOOKABLE_PACKAGE_RATE_ALL_ACTION = "BOOKABLE_PACKAGE_RATE_ALL_ACTION";
export const BOOKABLE_PACKAGE_RATE_ALL_SUCCESS = "BOOKABLE_PACKAGE_RATE_ALL_SUCCESS";